import { useContext } from 'react';
import { IModalRouterContext, ModalRouterContext } from '../../router/ModalRouter';
import useMobileApp from '../../../../hooks/mobile-app/useMobileApp';

const useModalRouter = (): IModalRouterContext => {
  const { isMobileApp } = useMobileApp();

  return (
    isMobileApp ? useContext<IModalRouterContext>(ModalRouterContext) : ModalRouterContext
  ) as IModalRouterContext;
};

export default useModalRouter;
